import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { DeleteDocumentImageDialog } from './DeleteDocumentImageDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('delete', () => <DeleteDocumentImageDialog />)
    .exhaustive()
}
